import { call, put, takeLatest } from "redux-saga/effects";
import { fetchRemindersQueueService } from "src/services/reminder.services";
import {
  fetchReminderQueue,
  setReminderQueue,
  setReminderQueueError,
} from "./slice";

function* handleFetchReminderQueue({ payload }: { payload?: any }) {
  try {
    const params = payload || {};
    const resp: any = yield call(fetchRemindersQueueService, params);
    yield put(setReminderQueue(resp));
  } catch (error: any) {
    yield put(setReminderQueueError(error?.message || "Failed to fetch queue"));
  }
}

export default function* reminderQueueSaga() {
  // action type produced by createSlice: 'reminderQueue/fetchReminderQueue'
  yield takeLatest(
    "reminderQueue/fetchReminderQueue",
    handleFetchReminderQueue as any
  );
}
